import { LAYOUT } from 'reactor/common';
import ASSETS from 'assets';
import C from '../constants';
import COUNTRIES from './mocks/countries.json';
import DOCUMENT from './mocks/document.json';

const { VIEWPORT: { LANDSCAPE } } = LAYOUT;

const PROFILE = {
  name: {
    inline: LANDSCAPE && 2,
    label: 'l10n.AGENCY_NAME',
    disabled: true,
  },
  id: {
    label: 'l10n.AGENCY_ID',
    disabled: true,
    inline: LANDSCAPE && 2,
  },
  email: {
    label: 'e-mail',
    disabled: true,
    inline: LANDSCAPE && 2,
  },
  phone: {
    inline: LANDSCAPE && 2,
    countryCode: true,
    keyboard: 'numeric',
    label: 'l10n.PHONE',
    minChar: 9,
  },

  web: { label: 'l10n.WEB', inline: LANDSCAPE && 2 },
  socialReason: {
    label: 'l10n.SOCIAL_REASON', inline: LANDSCAPE && 2, requiredIcon: true,
  },

  document: {
    title: 'l10n.DOCUMENT',
    attributes: {
      type: {
        label: 'l10n.TYPE',
        inline: LANDSCAPE && 2,
        type: 'select',
        dataSource: DOCUMENT,
        native: true,
        // defaultValue: C.DEFAULT_DOCUMENT,
      },
      value: { label: 'l10n.NUMBER', inline: LANDSCAPE && 2 },
    },
  },

  address: {
    title: 'l10n.INVOICE_ADDRESS',
    attributes: {
      street: {
        label: 'l10n.STREET', requiredIcon: true,
      },
      number: {
        label: 'l10n.NUMBER', inline: LANDSCAPE && 2, requiredIcon: true,
      },
      zip: {
        label: 'l10n.ZIP', inline: LANDSCAPE && 2, requiredIcon: true,
      },
      city: {
        label: 'l10n.CITY', inline: LANDSCAPE && 2, requiredIcon: true,
      },
      state: {
        label: 'l10n.PROVINCE', inline: LANDSCAPE && 2, requiredIcon: true,
      },
      country: {
        defaultValue: C.DEFAULT_COUNTRY,
        type: 'select',
        label: 'l10n.country',
        dataSource: Object.values(COUNTRIES).sort(),
        inline: LANDSCAPE && 2,
      },
    },
  },
};

const SIGN_IN = {
  username: { type: 'username', label: 'l10n.USERNAME', required: true },
  password: { label: 'l10n.PASSWORD', required: true, secureTextEntry: true },
};

const SIGN_UP = {
  email: { type: 'email', label: 'e-mail', required: true },
  password: { label: 'l10n.PASSWORD', required: true, secureTextEntry: true },
  repassword: { label: 'l10n.PASSWORD_REPEAT', required: true, secureTextEntry: true },
  name: { type: 'text', label: 'l10n.AGENCY_NAME', required: true },
  agencyId: { type: 'text', label: 'l10n.AGENCY_ID', required: true },
  web: { type: 'text', label: 'l10n.AGENCY_WEB', required: true },
  socialReason: { type: 'text', label: 'l10n.SOCIAL_REASON', required: true },
  document: {
    type: 'select',
    label: 'l10n.DOCUMENT_TYPE',
    dataSource: ['l10n.PASSPORT', 'l10n.ID_CARD', 'l10n.TAX_NUMBER'],
    defaultValue: 'l10n.PASSPORT',
  },
  documentId: { type: 'text', label: 'l10n.DOCUMENT_ID', required: true },
  street: { type: 'text', label: 'l10n.AGENCY_ADDRESS', required: true },
  number: {
    type: 'number', label: 'l10n.NUMBER', inline: 3, required: true,
  },
  zipCode: {
    type: 'text', label: 'l10n.l10n.ZIP', required: true, inline: 1,
  },
  city: { type: 'text', label: 'l10n.CITY', required: true },
  country: {
    defaultValue: C.DEFAULT_COUNTRY,
    type: 'select',
    label: 'l10n.country',
    dataSource: Object.values(COUNTRIES).sort(),
    required: true,
  },
  phone: { type: 'number', label: 'l10n.PHONE', required: true },
  // policy: { type: 'option', label: 'l10n.POLICY_TERMS', required: true },
};

const TABLE_BOOKINGS = {
  name: { label: 'l10n.BOOKING_NAME', style: { minWidth: '15%', maxWidth: '20%' } },
  userName: {
    label: 'l10n.CLIENT_NAME', style: { minWidth: '15%' }, type: 'object', field: 'userName',
  },
  userMail: {
    label: 'l10n.CLIENT_EMAIL', style: { minWidth: '15%' }, type: 'object', field: 'userMail',
  },
  created: { label: 'l10n.RESERVED' },
  date: { label: 'l10n.ENJOYED' },
  price: { label: 'l10n.PVP' },
  discount: { label: 'l10n.DTO_OVERFLOW' },
  agencyPrice: { label: 'l10n.PRICE_NET' },
  info: { icon: ASSETS.info, label: 'l10n.INFO', type: 'icon' },
};

const TABLE_BOOKING_EVENTS = {
  type: { label: 'l10n.EVENT' },
  createdAt: { label: 'l10n.DATE' },
};

const TABLE_CAMPAIGNS = {
  title: { label: 'l10n.NAME', style: { minWidth: '30%' } },
  type: { label: 'l10n.TYPE' },
  bookings: { label: 'l10n.BOOKINGS', type: 'number', style: { alignItems: 'center' } },
  clicks: { type: 'number', style: { alignItems: 'center' } },
  conversionRate: { label: 'l10n.CONVERSION', type: 'number', style: { alignItems: 'center' } },
  fee: { type: 'price', label: 'l10n.FEE', style: { alignItems: 'center' } },
};

const TABLE_INVOICES = {
  menu: {
    icon: ASSETS.menu,
    label: 'l10n.MENU',
    style: {
      maxWidth: '10%',
    },
    type: 'icon',
  },
  number: { label: 'l10n.INVOICE_NUM', type: 'number' },
  name: { label: 'l10n.INVOICE_ACTIVITY_NAME' },
  created: { label: 'l10n.INVOICE_DATE' },
  total: { label: 'l10n.INVOICE_PRICE' },
  fee: { label: 'l10n.INVOICE_FEE' },
  net: { label: 'l10n.INVOICE_NET_PRICE' },
};

const TABLE_STATS = {
  date: { label: 'l10n.DATE', style: { minWidth: '30%' } },
  clicks: { style: { alignItems: 'center' } },
  conversionRate: { label: 'conversion', style: { alignItems: 'center' } },
  fee: { label: 'l10n.FEE', type: 'price', style: { alignItems: 'center' } },
};

const DATE_RANGE = {
  period: {
    inline: 2,
    label: 'l10n.PERIOD',
    type: 'select',
    dataSource: 'l10n.PERIOD_DATASOURCE',
  },
  dates: {
    disabledPast: false,
    inline: 2,
    label: 'l10n.DATES',
    placeholder: 'l10n.CHOOSE_DATE',
    range: true,
    type: 'date',
  },
};

const DATE_AGENCIES_RANGE = {
  period: {
    inline: 2,
    label: 'l10n.PERIOD',
    type: 'select',
    dataSource: 'l10n.PERIOD_DATASOURCE',
  },
  dates: {
    disabledPast: false,
    inline: 2,
    label: 'l10n.DATES',
    placeholder: 'l10n.CHOOSE_DATE',
    range: true,
    type: 'date',
    style: { zIndex: '2' },
  },
  agencyChildName: {
    inline: 2,
    label: 'l10n.SELECT_AGENCY',
    type: 'select',
    dataSource: [],
    placeholder: 'Agencia',
    style: { zIndex: '1' },
  },
  dateFilter: {
    type: 'option', rounded: false, label: 'l10n.DATE_FILTER', required: true,
  },
  all: {
    type: 'option', rounded: false, label: 'l10n.ALL_CHILDS_FILTER', required: true,
  },
};

export default {
  DATE_RANGE,
  DATE_AGENCIES_RANGE,
  SIGN_IN,
  SIGN_UP,
  PROFILE,
  TABLE_BOOKINGS,
  TABLE_BOOKING_EVENTS,
  TABLE_CAMPAIGNS,
  TABLE_INVOICES,
  TABLE_STATS,
};
